import { Box, HStack } from "@chakra-ui/react";
import React from "react";
import LeftSidebar from "../../components/LeftSideBarLayout/LeftSideBar";
import HeaderBar from "../../components/Header/HeaderBar";
import RetailerSummary from "../../components/Retailer/RetailerSummary";
import Footer from "../../components/footer";

const Retailer = () => {
    return (
        <>
            <Box backgroundColor='#F0F4F9' height="100vh" overflow={"hidden"}>
                <HStack pl='20px' pr={"6px"} w={"100%"} spacing={0} alignItems='flex-start' overflow={"hidden"}>
                    <LeftSidebar />
                    <Box as="main" minW={0} flex={1} ml={"6px"} overflow={"hidden"}>
                        <HeaderBar />
                        <RetailerSummary />
                        <Footer />
                    </Box>
                </HStack>
            </Box>
        </>
    )
}

export default Retailer